export default class SigGenerator {
  constructor(root) {
    this.root = root;
    this.current_type = 'tn';
    this.current_social_type = 'consumer';
    this.current_office_phone = '';
    this.current_cell_phone = '';
    this.show_social = true;

    this.sig_types = this.root.querySelectorAll('input[name="sig-type"]');
    this.name_field = this.root.querySelector('form [name="full-name"]');
    this.secondary_field = this.root.querySelector('form [name="secondary-line"]');
    this.title_field = this.root.querySelector('form [name="title"]');
    this.office_phone_field = this.root.querySelector('form [name="office-phone"]');
    this.cell_phone_field = this.root.querySelector('form [name="cell-phone"]');
    this.linkedin_field = this.root.querySelector('form [name="linkedin"]');
    this.show_social_field = this.root.querySelector('form [name="show-social"]');
    this.social_types_fields = this.root.querySelectorAll('form [name="sig-social-type"]');
    this.show_industry_field = this.root.querySelector('form [name="show-industry"]');

    this.copy_btns = this.root.querySelectorAll('.js-sig-copy-btn');
    this.copy_container = this.root.querySelector('.js-sig-copy-container');

    this.sig_types.forEach((sig_type) => {
      sig_type.addEventListener('click', (e) => {
        this.current_type = e.target.value;

        if(this.current_type == 'tn') {
          this.secondary_field.setAttribute('type', 'hidden');
        } else if(this.current_type == 'nv-mag') {
          this.secondary_field.setAttribute('type', 'text');
        }

        let input_event = new Event('input', { bubbles: true });
        this.title_field.dispatchEvent(input_event);
        this.secondary_field.dispatchEvent(input_event);
        this.switchLinks();
        this.updatePhone();
      });
    });

    this.name_field.addEventListener('input', (e) => {
      this.updateValues('full-name', e.target.value);
    });

    this.title_field.addEventListener('input', (e) => {
      let new_value = '';

      if(this.current_type == 'tn') {
        new_value = e.target.value;
        this.title_field.setAttribute('placeholder', 'Title');
      } else if(this.current_type == 'nv-mag' && e.target.value != '') {
        new_value = e.target.value + ', Travel Nevada';
        this.title_field.setAttribute('placeholder', 'Travel Nevada Title');
      } else {
        this.title_field.setAttribute('placeholder', 'Travel Nevada Title');
      }

      this.updateValues('title', new_value);
    });

    this.secondary_field.addEventListener('input', (e) => {
      let new_value = '';

      if(this.current_type == 'nv-mag' && e.target.value != '') {
        new_value = e.target.value + ', <em>Nevada Magazine & Visitor Guide</em>';
      }

      this.updateValues('secondary-line', new_value);
    });

    this.office_phone_field.addEventListener('input', (e) => {
      this.current_office_phone = this.formatPhoneNumber(e.target.value);
      this.updatePhone();
    });

    this.cell_phone_field.addEventListener('input', (e) => {
      this.current_cell_phone = this.formatPhoneNumber(e.target.value);
      this.updatePhone();
    });

    this.copy_btns.forEach((copy_btn) => {
      copy_btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.target.disabled = true;
        e.target.innerText = 'Copied';
        this.copyContainer(e.target.previousElementSibling);

        setTimeout(() => {
          e.target.disabled = false;
          e.target.innerText = 'Copy';
        }, 3000);
      });
    });

    this.linkedin_field.addEventListener('input', (e) => {
      this.updateValues('linkedin', '<span style="color: black;">Connect with me on </span><a href="' + this.linkedin_field.value + '" style="color: #ff571b;">LinkedIn</a>');
    });

    this.social_types_fields.forEach((social_type_field) => {
      social_type_field.addEventListener('click', (e) => {
        this.current_social_type = e.target.value;
        this.updateSocials();
      });
    });

    this.show_social_field.addEventListener('input', (e) => {
      this.show_social = e.target.checked;

      this.social_types_fields.forEach((social_type_field) => {
        if(e.target.checked) {
          social_type_field.parentElement.style.display = 'inherit';
        } else {
          social_type_field.parentElement.style.display = 'none';
        }
      });

      this.updateSocials();
    });

    this.show_industry_field.addEventListener('input', (e) => {
      if(e.target.checked) {
        this.updateValues('trailblazer', '<br/>Become a certified Nevada expert:<br/>Register for <a href="https://nvtrailblazers.travelnevada.com/login" style="color: #ff571b;">NV Trailblazers</a>');
      } else {
        this.updateValues('trailblazer', '');
      }
    });
  }

  updateSocials() {
    let consumer_visibility = 'none';
    let industry_visibility = 'none';

    if(this.show_social && this.current_social_type == 'consumer') {
      consumer_visibility = 'inherit';
    } else if(this.show_social && this.current_social_type == 'industry') {
      industry_visibility = 'inherit';
    }

    this.updateValues('social-consumer', (elem) => {
      elem.parentElement.style.display = consumer_visibility;
    });
    this.updateValues('social-industry', (elem) => {
      elem.parentElement.style.display = industry_visibility;
    });
  }

  updatePhone() {
    let new_value = '';

    if(this.current_office_phone && this.current_cell_phone) {
      new_value = 'o: <strong>' + this.current_office_phone + '</strong>' + (this.current_type == 'tn' ? '<br/>' : ' ') + 'c: <strong>' + this.current_cell_phone + '</strong>';
    } else if(this.current_office_phone) {
      new_value = '<strong>' + this.current_office_phone + '</strong>';
    } else if(this.current_cell_phone) {
      new_value = '<strong>' + this.current_cell_phone + '</strong>';
    }

    this.updateValues('phone', new_value);
  }

  switchLinks() {
    if(this.current_type == 'tn') {
      this.updateValues('separator', (elem) => {
        elem.style.display = 'none';
      });
      this.updateValues('nv-mag-link', (elem) => {
        elem.style.display = 'none';
      });
    } else if(this.current_type == 'nv-mag') {
      this.updateValues('separator', (elem) => {
        elem.style.display = 'inline';
      });
      this.updateValues('nv-mag-link', (elem) => {
        elem.style.display = 'inline';
      });
    }
  }

  updateValues(name, value) {
    let elems = this.root.querySelectorAll('.js-sig-' + name);

    if(elems) {
      elems.forEach((elem) => {
        if(typeof value == 'function') {
          value(elem);
        } else {
          elem.innerHTML = value;
        }
      });
    }
  }

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    if(cleaned.length > 10 && cleaned.charAt(0) == '1') {
      cleaned = cleaned.substring(1);
    }
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phoneNumberString;
  }

  copyContainer(container) {
    //copy content to workable container
    this.copy_container.appendChild(container.cloneNode(true));

    //remove empty tags
    this.copy_container.querySelectorAll('[class*="js-sig"]').forEach((field) => {
      if(field.innerHTML == '') {
        field.parentElement.remove();
      }

      if(field.classList.contains('js-sig-nv-mag-link') && field.style.display == 'none') {
        field.remove();
      } else if(field.classList.contains('js-sig-separator') && field.style.display == 'none') {
        field.remove();
      }

      if(field.classList.contains('js-sig-social-consumer') && field.parentElement.style.display == 'none') {
        field.parentElement.remove();
      } else if(field.classList.contains('js-sig-social-industry') && field.parentElement.style.display == 'none') {
        field.parentElement.remove();
      }
    });

    //perform system clipboard copy
    window.getSelection().removeAllRanges();
    var range = document.createRange();
    range.selectNode(this.copy_container.firstElementChild);
    window.getSelection().addRange(range);
    document.execCommand('copy');

    setTimeout(() => {
      this.copy_container.innerHTML = '';
    }, 1000);
  }
}
  